import { NavLink } from 'react-router'
import GoogleMapsIcon from '../../../components/icons/GoogleMapsIcon'
import { Meeting } from '../../../generated'

//TODO: Replace with cloudflare
const addressPlaceholder =
  'https://dfc6zulft4rm9.cloudfront.net/images/address-placeholder.jpg'

export default function MeetingCard({ meeting }: { meeting: Meeting }) {
  const emptyLocation =
    meeting.locationFullAddress === 'TBD' || !meeting.locationFullAddress
  const address = emptyLocation ? (
    meeting.locationFullAddress
  ) : (
    <div className="flex items-center gap-1.5 font-sans text-base font-normal leading-relaxed text-blue-gray-900 antialiased">
      <a
        className="font-medium text-blue-600 underline dark:text-blue-500"
        target="_blank"
        rel="noopener noreferrer"
        href={`https://maps.google.com/?q=${meeting.locationName} ${meeting.locationFullAddress}`}>
        {meeting.locationFullAddress}
      </a>
      <GoogleMapsIcon />
    </div>
  )

  return (
    <div className="relative flex w-full max-w-[26rem] flex-col rounded-xl bg-white bg-clip-border text-gray-700 shadow-lg mt-6">
      <div className="relative mx-4 mt-4 overflow-hidden text-white shadow-lg rounded-xl bg-blue-gray-500 bg-clip-border shadow-blue-gray-500/40">
        <img
          src={
            meeting.addressLogoUrl ? meeting.addressLogoUrl : addressPlaceholder
          }
          alt="Address Logo"
          style={{ height: 216, width: '100%', objectFit: 'cover' }}
        />
      </div>
      <div className="p-6">
        <div className="flex items-center justify-between mb-3">
          <h5 className="block font-sans text-xl antialiased font-medium leading-snug tracking-normal text-blue-gray-900">
            {meeting.meetingName} @ "{meeting.locationName}"
          </h5>
        </div>
        <p className="block font-sans text-base antialiased font-light leading-relaxed text-gray-700 mb-3">
          {meeting.startDateTime} - {meeting.endTime}
        </p>
        <div className="block font-sans text-base antialiased font-light leading-relaxed text-gray-700">
          {address}
        </div>
      </div>
      {meeting.isRegularEvent && (
        <div className="p-6 pt-3">
          <NavLink
            to={`/club/${meeting.clubId}/meeting/${meeting.timestampUtc}`}
            className="block w-full select-none rounded-lg bg-gray-800 py-3.5 px-7 text-center align-middle font-sans text-sm font-bold uppercase text-white shadow-md shadow-gray-500/20 transition-all hover:shadow-lg hover:shadow-gray-500/40 focus:opacity-[0.85] focus:shadow-none active:opacity-[0.85] active:shadow-none disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none"
            type="button"
            data-ripple-light="true">
            See details
          </NavLink>
        </div>
      )}
    </div>
  )
}
